// extracted by mini-css-extract-plugin
export default {"root":"ADE4f","left":"_2Bb0G","right":"_3-rRW"};